import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../../services/http/http";
import { updateUserData } from "./reducerUser";

const apiUrl = "https://mu-beginning.co.il/api/vote";

export const fetchVotePage = createAsyncThunk("vote/fetchPage", async () => {
  const response = await http.get(`${apiUrl}/`);
  return response.data;
});

export const startTop100Arena = createAsyncThunk(
  "vote/startTop100Arena",
  async (_, { rejectWithValue }) => {
    try {
      const response = await http.post(`${apiUrl}/top100arena/start`, {});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { ok: false, code: "INTERNAL_ERROR" },
      );
    }
  },
);

export const statusTop100Arena = createAsyncThunk(
  "vote/statusTop100Arena",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await http.post(`${apiUrl}/top100arena/status`, {});
      if (response.data?.code === "BCOIN_RECEIVED" && response.data?.user) {
        dispatch(
          updateUserData({
            username: response.data.username,
            user: response.data.user,
          }),
        );
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { ok: false, code: "INTERNAL_ERROR" },
      );
    }
  },
);

export const checkMutop100 = createAsyncThunk(
  "vote/checkMutop100",
  async (_, { rejectWithValue }) => {
    try {
      const response = await http.post(`${apiUrl}/mutop100/check`, {});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          ok: false,
          code: "PROVIDER_TEMPORARILY_UNAVAILABLE",
        },
      );
    }
  },
);

export const claimMutop100 = createAsyncThunk(
  "vote/claimMutop100",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await http.post(`${apiUrl}/mutop100/claim`, {});
      if (response.data?.user && response.data?.username) {
        dispatch(
          updateUserData({
            username: response.data.username,
            user: response.data.user,
          }),
        );
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          ok: false,
          code: "PROVIDER_TEMPORARILY_UNAVAILABLE",
        },
      );
    }
  },
);

const initialState = {
  page: { data: null, status: "" },
  action: { data: null, status: "", code: "" },
};

const voteApi = createSlice({
  name: "MuBeginningVote",
  initialState,
  reducers: {
    clearVoteAction(state) {
      state.action = { data: null, status: "", code: "" };
    },
  },
  extraReducers: {
    [fetchVotePage.pending]: (state) => {
      state.page.status = "pending";
    },
    [fetchVotePage.fulfilled]: (state, { payload, meta }) => {
      state.page.data = payload;
      state.page.status = meta.requestStatus;
    },
    [fetchVotePage.rejected]: (state, { meta }) => {
      state.page.status = meta.requestStatus;
    },
    [startTop100Arena.fulfilled]: (state, { payload, meta }) => {
      state.action.data = payload;
      state.action.status = meta.requestStatus;
      state.action.code = payload?.code || "";
    },
    [statusTop100Arena.fulfilled]: (state, { payload, meta }) => {
      state.action.data = payload;
      state.action.status = meta.requestStatus;
      state.action.code = payload?.code || "";
    },
    [checkMutop100.fulfilled]: (state, { payload, meta }) => {
      state.action.data = payload;
      state.action.status = meta.requestStatus;
      state.action.code = payload?.code || "";
    },
    [claimMutop100.fulfilled]: (state, { payload, meta }) => {
      state.action.data = payload;
      state.action.status = meta.requestStatus;
      state.action.code = payload?.code || "";
    },
    [startTop100Arena.rejected]: (state, { meta, payload }) => {
      state.action.status = meta.requestStatus;
      state.action.data = payload || null;
      state.action.code = payload?.code || "INTERNAL_ERROR";
    },
    [checkMutop100.rejected]: (state, { meta, payload }) => {
      state.action.status = meta.requestStatus;
      state.action.data = payload || null;
      state.action.code = payload?.code || "INTERNAL_ERROR";
    },
    [claimMutop100.rejected]: (state, { meta, payload }) => {
      state.action.status = meta.requestStatus;
      state.action.data = payload || null;
      state.action.code = payload?.code || "INTERNAL_ERROR";
    },
    [statusTop100Arena.rejected]: (state, { meta, payload }) => {
      state.action.status = meta.requestStatus;
      state.action.data = payload || null;
      state.action.code = payload?.code || "INTERNAL_ERROR";
    },
  },
});

export const { clearVoteAction } = voteApi.actions;
export default voteApi.reducer;
